import ObjectBuilderInterface from "@/modules/api/object-builder.interface";
import ExtraChargeOption from "./extra-charge-option.model";

export default class ExtraChargeOptionFactory
  implements ObjectBuilderInterface<ExtraChargeOption> {
  public buildFromJSON(data: { [key: string]: any }): ExtraChargeOption {
    const isMultiplePurchaseAllowed =
      data.isMultiplePurchaseAllowed !== undefined &&
      data.isMultiplePurchaseAllowed !== null
        ? Boolean(data.isMultiplePurchaseAllowed)
        : undefined;

    return new ExtraChargeOption(
      data.upgradeCode,
      data.upgradeName,
      Boolean(data.isSelectable),
      isMultiplePurchaseAllowed
    );
  }
}
